import { Box, Modal } from '@mui/material';

import ModalStyle from '@/constants/ModalStyle';
import alert from '@/assets/icons/alert.png';

export default function Delete(props) {
	const { data, open, onClose, onSave, textWarning = 'Er du sikker på at du vil slette' } = props;

	const onDeleteProject = () => {
		if (!data) return;
		onSave();
	};
	return (
		<Modal open={open} onClose={onClose} aria-labelledby='modal-project-qr' aria-describedby='modal-project-qr' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25svh' }} className='!bg-bd-blue relative flex flex-col gap-4 min-w-[300px] w-auto h-auto'>
				<div className='flex flex-col items-center justify-center w-full h-auto gap-4 text-center'>
					<img src={alert} alt='warning' />
					<div className='flex flex-col text-white'>
						<span>{textWarning} </span>
						<span>
							{data?.name}?
						</span>
					</div>
					<div className='flex gap-4'>
						<button className='btn-action bg-[#81B8DD] btn text-bd-blue' onClick={onClose}>
							Nei
						</button>
						<button className='bg-white btn-action btn text-bd-blue' onClick={onDeleteProject} disabled={!data}>
							Ja
						</button>
					</div>
				</div>
			</Box>
		</Modal>
	);
}
